import React from 'react'
import * as d3 from 'd3'

import { useTheme } from '@mui/material/styles'

import { arcTween } from '../../utils/BubblesSVG'

import type { BubbleData } from '../BubbleChart'

const PROGRESS_INDICATOR_SIZE = 5
const PROGRESS_DURATION = 2000

interface MercuryProps {
  bubble: BubbleData
}

const Mercury = ({ bubble }: MercuryProps) => {
  const theme = useTheme()
  const {
    amount,
    guid,
    budgetColors: { mercury },
    radius,
    transaction_total,
  } = bubble

  const bubbleId = `mercury-${guid}`

  React.useEffect(() => {
    // Remove previous status arc
    d3.select(`.${bubbleId}`).selectAll('.status').remove()

    // Append updated status arc
    d3.select(`.${bubbleId}`)
      .append('path')
      .transition()
      .duration(PROGRESS_DURATION)
      .delay(0)
      .attr('class', 'status')
      .attr('style', `fill: ${mercury}; fill-opacity: 1;`)
      .attrTween('d', () => arcTween(bubble))
  }, [amount, radius, transaction_total])

  const trackArc = d3
    .arc<number>()
    .innerRadius((radius: number) => radius - 2 * PROGRESS_INDICATOR_SIZE)
    .outerRadius((radius: number) => radius - PROGRESS_INDICATOR_SIZE)
    .startAngle(0)
    .endAngle(2 * Math.PI)

  return (
    <g className={bubbleId}>
      <path
        d={trackArc(radius) || ''}
        style={{ fill: theme.palette.common.white, fillOpacity: 0.35 }}
      />
    </g>
  )
}

export default React.memo(Mercury)
